/**** cat.DevMNTType */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Routes',
  title: 'Маршруты',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    transporttype: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'TransportType',
      index: 'note',
      fields: ['title'],
      format: (elem: any) => elem['title'],
    },
    marshtype: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'MarshType',
      index: 'id',
      fields: ['title'],
      format: (elem: any) => elem['title'],
      autocomplete: true
    },
    depots: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Depot',
      index: 'depot_id',
      fields: ['depot_name'],
      format: (elem: any) => elem['depot_name'],
    }
  },
  fields: [
    {
      name: 'route_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'route_long_name',
      title: 'Наименование',
      type: 'text',
      required: true,
      width: '30%',
    },
    {
      name: 'route_type',
      title: 'Тип ТС',
      type: 'text',
      required: true,
      connection: 'transporttype',
    },
    {
      name: 'MarshType_id',
      title: 'Вид сообщения',
      type: 'number',
      required: true,
      connection: 'marshtype',
    },
    {
      name: 'route_short_name',
      title: 'Номер маршрута',
      type: 'text',
      required: true,
      width: '30%',
    },
    {
      name: 'route_desc',
      title: 'Альтернативное наименование',
      type: 'text',
      required: true,
      width: '30%',
    },
    {
      name: 'Depot_id',
      title: 'Филиал',
      type: 'number',
      required: false,
      connection: 'depots',
    },
    {
      name: 'Agency_id',
      hide: true,
    },
    {
      name: 'startdate',
      title: 'Дата ввода в действие',
      type: 'date',
      required: false,
    },
    {
      name: 'enddate',
      title: 'Дата окончания действие',
      type: 'date',
      required: false,
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px'
    }
  ],
  newTemplate: {
    route_id: null,
    route_long_name: '',
    route_type: null,
    MarshType_id: null,
    route_short_name: '',
    route_desc: '',
    do_not_update: true
  },
  makeIdOnInsert: true,
  updateField: 'update_date',
  defaultSort: {
    field: 'route_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'route_id',
        field: 'route_id',
      },{
        title: 'route_name',
        field: 'route_long_name',
      },
      {
        title: 'ts_type_code',
        field: 'route_type',
      },
      {
        title: 'transfer_id',
        field: 'MarshType_id',
      },
      {
        title: 'route_num',
        field: 'route_short_name',
      },
      {
        title: 'route_alt_name',
        field: 'route_desc',
      },
      {
        title: 'depot_id',
        field: 'Depot_id',
      },
      {
        title: 'route_date_start',
        field: 'startdate',
      },
      {
        title: 'route_date_end',
        field: 'enddate',
      }
    ],
    example: `1;Название маршрута;А;1;11;Route name;1;2020-01-01 00:00:00.000;2030-01-01 00:00:00.000`,
  },
  export: {
    connections: {
      agencies: {
        schema: 'mgt',
        table: 'Agency',
        index: 'agency_id',
        fields: ['title'],
      },
    },
    fields: [
      {
        name: 'route_long_name',
        title: 'Наименование',
      },
      {
        name: 'route_type',
        title: 'Тип ТС',
        connectionGetField: 'title'
      },
      {
        name: 'MarshType_id',
        title: 'Вид сообщения',
        connectionGetField: 'title'
      },
      {
        name: 'route_short_name',
        title: 'Номер маршрута',
      },
      {
        name: 'route_desc',
        title: 'Альтернативное наименование',
      },
      {
        name: 'agency_id',
        title: 'Предприятие перевозчик',
        connection: 'agencies',
        connectionKey: 'Agency_id',
        connectionGetField: 'title',
      },
      {
        name: 'Depot_id',
        title: 'Филиал',
        connection: 'depots',
      },
      {
        name: 'startdate',
        title: 'Дата ввода в действие',
      },
      {
        name: 'enddate',
        title: 'Дата окончания действие',
      },
    ],
  },
};

export default config;
